<template>
  <el-dialog
    v-drag
    title="筛选详情"
    :visible.sync="dialogVisible"
    width="1300px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="total">
      <div>总金额：<span class="red">{{ totalAmount }} USD</span></div>
      <div>总条数：<span class="red">{{ total }}</span></div>
    </div>
    <div class="content">
      <BaseTable
        ref="myTabel"
        :key="dialogVisible"
        height="540"
        :tableData="tableData"
        :loading="loading"
        :isPager="false"
        :border="true"
        @sortChange="sortChange"
      ></BaseTable>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { throttle } from '@/utils/common'
import {
  getPayableDetailPages
} from '@/api/fee'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'invoiceNumber',
            label: '发票号',
            width: '120',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'blNo',
            label: '提单号',
            width: '120',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '110',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'supplieName',
            label: '供应商',
            width: '100',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'companyName',
            label: '客户',
            width: '130',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'feeTypeAndName',
            label: '费用项',
            width: '140',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'mblSendWayName',
            label: '派送方式',
            width: '110',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'apUnit',
            label: '单位',
            width: '70',
            isSort: true,
            align: 'left',
            formatter: (row) => row.apUnitName ? row.apUnitName : ''
          },
          {
            filed: 'qty',
            label: '数量',
            width: '70',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: '70',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'totalAmount',
            label: '金额',
            width: '80',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'defrayNumber',
            label: '申付单号',
            width: '110',
            isSort: true,
            align: 'left'
          },
          {
            filed: 'remark',
            label: '备注',
            width: '110',
            isSort: true,
            align: 'left'
          }
        ],
        columns: []
      },
      loading: false,
      listStatus: true,
      pager: {
        pageIndex: 1,
        pageSize: 100
      },
      totalAmount: 0,
      total: 0,
      orderObj: {},
      isSort: false
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.listStatus = true
        this.getLists(this.pager)
        // 触底更新
        this.$nextTick(() => {
          this.$refs.myTabel.$refs.multipleTable.bodyWrapper.addEventListener('scroll', (res) => {
            const target = res.target
            const clientHeight = target.clientHeight
            const scrollTop = target.scrollTop
            const scrollHeight = target.scrollHeight
            if (clientHeight + scrollTop === scrollHeight && this.listStatus) {
              this.getLists('add')
            }
          }, true)
        })
      }
    }
  },
  methods: {
    getLists: throttle(async function(params) {
      try {
        this.loading = true
        if (params === 'add') {
          this.pager = {
            pageIndex: this.pager.pageIndex + 1,
            pageSize: 100
          }
          params = {
            ...this.pager,
            queryParam: {
              ...this.filter,
              ...this.orderObj
            }
          }
        } else {
          params = {
            ...params,
            queryParam: {
              ...this.filter,
              ...this.orderObj
            }
          }
        }
        const res = await getPayableDetailPages(params)
        this.loading = false
        if (res.success) {
          if (res.data.list.length === 0 && this.listStatus) {
            this.listStatus = false
            return
          }
          if (JSON.stringify(this.orderObj) === '{}' || !this.isSort) {
            this.tableData.columns.push(...res.data.list)
          } else if (this.isSort && this.orderObj?.sortField) {
            this.tableData.columns = res.data.list
          }
          this.totalAmount = this.totalAmount || res.data.totalAmount
          this.total = this.total || res.data.total
          this.isSort = false
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }, 500),
    cancel() {
      this.totalAmount = 0
      this.total = 0
      this.currency = ''
      this.tableData.columns = []
      this.pager = {
        pageIndex: 1,
        pageSize: 100
      }
      this.$emit('cancel')
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.orderObj = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
        this.isSort = true
      } else {
        this.isSort = false
        this.orderObj = {}
      }
      const pager = {
        pageIndex: 1,
        pageSize: this.pager.pageIndex * 100
      }
      this.getLists(pager)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  position: relative;
  border: 0;
  z-index: 1;
}
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 20px;
}
.content {
  width: 100%;
  /deep/ .fTable {
    tr td {
      padding: 0;
      .cell {
        font-size: 12px;
      }
    }
  }
}
.total {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  div {
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    & + div {
      margin-left: 40px;
    }
  }
  .red {
    color: #FE453D;
  }
}
</style>
